import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $attachClientToPartnerProfile,
  $errorAttachClientToPartner,
  attachClientToPartnerProfileMounted,
  setAttachClientToPartnerProfile,
  updatePartner,
} from './model'
import exp from 'constants'

export const useAttachClientToPartnerProfile = () => {
  let attachClientToPartnerProfile = useStore($attachClientToPartnerProfile)
  const loading = useStore(updatePartner.pending)
  const errorAttachClientToPartner = useStore($errorAttachClientToPartner)

  React.useEffect(() => {
    attachClientToPartnerProfileMounted()
  }, [])

  return { attachClientToPartnerProfile, loading, errorAttachClientToPartner }
}
